import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Personal Projects`}</h2>
    <ProjectCard title="Netflix Clone" link="https://netflix-clone-max61077.vercel.app/" bg="linear-gradient(to right, #D5175A 0%, #F8B04B 100%)" mdxType="ProjectCard">
Build using Next JS (13), Used Typescript, TailwindCSS for styling, Prisma client as ORM and MongoDB for storing Videos and User data. 
    </ProjectCard>
    <ProjectCard title="Instagram Clone" link="https://instagram-clone-rgdh.onrender.com/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Used MongoDb, Express, React js, Node Js (MERN Stack), Also JWT for authentication and SendGrid Api for sending emails.
    </ProjectCard>
    <ProjectCard title="Sketch Room" link="https://sketch-room.onrender.com/" bg="linear-gradient(to right, #232F34 0%, #416572 100%)" mdxType="ProjectCard">
This is an online multiplayer game made with NodeJs, Socket.io.
    </ProjectCard>
    <ProjectCard title="2 Cars" link="https://max61077.github.io/2-Cars/" bg="linear-gradient(to right, #112345 0%, #ff0000 100%)" mdxType="ProjectCard">
This is a concentration game using p5.js library(HTML5 Canvas).
    </ProjectCard>
    <ProjectCard title="Snakes-N-Ladders" link="https://max61077.github.io/Snakes-N-Ladders" bg="linear-gradient(to right, #234567 0%, #ffaabb 100%)" mdxType="ProjectCard">
Made using Plain Javascript, HTML and CSS.
    </ProjectCard>
    <ProjectCard title="Match The Colors" link="https://max61077.github.io/Match-The-Colors/" bg="linear-gradient(to right, #111211 0%, #0000ff 100%)" mdxType="ProjectCard">
Made using Plain Javascript, HTML and CSS.
    </ProjectCard>
    <ProjectCard title="Shoot the Blocks" link="https://max61077.github.io/shoot-the-blocks/" bg="linear-gradient(to right, #100232 0%, #ffccbb 100%)" mdxType="ProjectCard">
Made using p5.js library(HTML5 Canvas).
    </ProjectCard>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      